// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-70760218]{--tw-text-opacity:1!important;color:#fff!important}@supports (color:rgb(0 0 0/0)) and (top:var(--f )){a[data-v-70760218]{color:rgb(255 255 255/var(--tw-text-opacity))!important}}a[data-v-70760218]:hover{text-decoration-line:none!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
